import angular from 'angular';
import ArchivedAnnouncementsComponent from './archived-announcements-component';

export default angular.module('archived-announcements', []).component('archivedAnnouncements', new ArchivedAnnouncementsComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/archived-announcements/archived-announcements-module.js